<template>
  <div id="user-account" class="container-fluid">
    <div id="applicator-cta" class="panel panel-info" v-show="!isCertified && !applicationSubmitted">
      <div class="panel-body">
        <div class="col-xs-8 col-sm-8 text-center">
          <span>
            <h2>Want To Become a Certified Applicator?</h2>
          </span>
        </div>

        <div class="col-xs-4 col-sm-4">
          <a href="https://forms.monday.com/forms/fd0c75d093a1d4eb3461b20ce05bde5e?r=use1" class="btn btn-block btn-info" target="_blank">Apply Now</a>
        </div>

        <QualifiedApplication @application-submitted="submitApplication" ref="reload" />
      </div>
    </div>

    <div id="account-forms">
      <div class="col-lg-3 col-md-4 col-xs-12">
        <AccountCard :client_id="$attrs.client_id" :isLoggedIn="isLoggedIn" :me="me" :isOnMobile="isOnMobile" />
      </div>

      <div class="col-lg-9 col-md-8 col-xs-12">
        <!-- Nav tabs -->
        <ul class="nav nav-tabs" role="tablist" v-if="!isOnMobile">
          <li role="presentation" class="active"><a href="#account" aria-controls="account" role="tab" data-toggle="tab">Account</a></li>
          <li role="presentation"><a href="#payment-options" aria-controls="payment-options" role="tab" data-toggle="tab">Payment Options</a></li>
          <li role="presentation"><a href="#shipping-addresses" aria-controls="shipping-addresses" role="tab" data-toggle="tab">Shipping Addresses</a></li>
          <li role="presentation"><a href="#billing-addresses" aria-controls="billing-addresses" role="tab" data-toggle="tab">Billing Addresses</a></li>
        </ul>

        <ul class="nav nav-tabs" role="tablist" v-else>
          <li role="presentation" class="dropdown">
            <a href="#" id="mobile-tab-menu" class="dropdown-toggle" data-toggle="dropdown" aria-controls="mobile-tab-menu-contents" aria-expanded="true">Menu <span class="caret"></span></a>

            <div class="dropdown-backdrop"></div>
            <ul class="dropdown-menu" aria-labelledby="mobile-tab-menu" id="mobile-tab-menu-contents">
              <li role="presentation"><a href="#account" aria-controls="account" role="tab" data-toggle="tab">Account</a></li>
              <li role="presentation"><a href="#payment-options" aria-controls="payment-options" role="tab" data-toggle="tab">Payment Options</a></li>
              <li role="presentation"><a href="#shipping-addresses" aria-controls="shipping-addresses" role="tab" data-toggle="tab">Shipping Addresses</a></li>
              <li role="presentation"><a href="#billing-addresses" aria-controls="billing-addresses" role="tab" data-toggle="tab">Billing Addresses</a></li>
            </ul>
          </li>
        </ul>

        <!-- Tab panes -->
        <div class="tab-content">
          <div role="tabpanel" class="tab-pane active" id="account">
            <ProfileEditForm @set-is-certified="setIsCertified" :isLoggedIn="isLoggedIn" :me="me" :isOnMobile="isOnMobile" />
          </div>
          <div role="tabpanel" class="tab-pane" id="payment-options">
            <PaymentOptionList />
          </div>
          <div role="tabpanel" class="tab-pane" id="shipping-addresses">
            <AddressList :address-type="'shipping'" />
          </div>
          <div role="tabpanel" class="tab-pane" id="billing-addresses">
            <AddressList :address-type="'billing'" />
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
  import AccountCard from './AccountCard.vue';
  import ProfileEditForm from './ProfileEditForm.vue';
  import PaymentOptionList from './PaymentOptionList.vue';
  import AddressList from './AddressList.vue';
  import QualifiedApplication from './qualifiedApplication.vue';

  export default {
    name: 'main-user-account',

    components: {
      AccountCard,
      ProfileEditForm,
      PaymentOptionList,
      AddressList,
      QualifiedApplication,
    },

    data() {
      return {
        applicationSubmitted: false,
        isCertified: false,
      };
    },

    computed: {
      isLoggedIn() {
        return this.$root.isLoggedIn;
      },

      me() {
        return this.$root.me;
      },

      isOnMobile() {
        return this.$root.$mq !== 'desktop';
      },
    },

    watch: {
      isLoggedIn(loggedIn) {
        if (loggedIn) {
          this.accountDetails = this.me;

          if (this.me.badges.includes('certified')) {
            this.applicationSubmitted = true;
          }
        }
      },
    },

    methods: {
      setIsCertified(profileOptionValue) {
        this.isCertified = profileOptionValue;
      },

      submitApplication() {
        this.applicationSubmitted = true;
      },

      openQualifiedApplication() {
        this.$refs.reload.reloadModal();
        $('#qualifiedApplication').modal('show');
      },
    },
  };
</script>

<style lang="scss" scoped>
  #user-account {
    margin: 2% 10%;

    #applicator-cta {
      margin: 0 15px 40px 15px;

      .panel-body {
        padding: 30px;

        h2 {
          margin: 0;
          line-height: 42px;
        }

        .btn-info {
          padding: 10px 20px;
        }
      }
    }

    #account-forms {
      .col-lg-9, .col-md-6, .col-xs-12 {
        .tab-content {
          padding: 5px 30px 30px 30px;
          background-color: #fff;
          border: 1px solid #ddd;
          border-top: 0;
        }
      }
    }

    .nav-tabs > li > a {
      border-radius: 0;
    }

    .sidebar {
      margin-top: 0;
    }
  }

  @media only screen and (max-width: 1600px) {
    #user-account {
    margin: 2% 0%
    }
  }

  @media only screen and (max-width: 770px) {
    #account-forms {
      .col-lg-9, .col-md-6, .col-xs-12 {
        display: grid;
      }
    }
  }
</style>